import React from 'react';
import ButtonInc from '../../../../../../shared-ui/ButtonInc';
import MemberBenefitsTable from '../../shared/Components/MemberBenefitsTable';
import PolicyInfoHeader from '../../shared/Components/PolicyInfoHeader';
import PremiumComparisonBox from '../../shared/Components/PremiumComparisonBox';
import AmendmentPageHeader from '../../shared/Components/AmendmentPageHeader';

/**
 * Screen for upgrade (Member Only → Member & Family)
 * Shows premium change preview
 */
const UpgradePreviewScreen = ({
  principal,
  allMembers = [],
  oldPremium,
  newPremium,
  policy,
  onNext,
  onCancel
}) => {

  // Categorize members
  const nuclearMembers = allMembers.filter(m =>
    ['Principal', 'Spouse', 'Child'].includes(m.relationship)
  );
  const parentMembers = allMembers.filter(m =>
    ['Parent', 'Parent_In_Law', 'Father', 'Mother', 'Father In Law', 'Mother In Law'].includes(m.relationship)
  );
  const extendedMembers = allMembers.filter(m =>
    !['Principal', 'Spouse', 'Child', 'Parent', 'Parent_In_Law', 'Father', 'Mother', 'Father In Law', 'Mother In Law'].includes(m.relationship)
  );

  // No action button needed for upgrade preview (read-only view)
  const renderActionButton = () => null;

  return (
    <div style={{ padding: '20px', maxWidth: '1000px', margin: '0 auto' }}>
      {/* Header */}
      <AmendmentPageHeader
        title="Change Coverage Type"
        subtitle="Premium update preview"
        onBack={onCancel}
      />

      {/* Policy Information */}
      <PolicyInfoHeader policy={policy} />

      {/* Premium Comparison */}
      <PremiumComparisonBox
        oldPremium={oldPremium}
        newPremium={newPremium}
        oldLabel="Current Premium (Member Only)"
        newLabel="New Premium (Member & Family)"
        noteText={<><strong>Note:</strong> You can add additional family members later using the <strong>Manage Members</strong> amendment.</>}
      />

      <MemberBenefitsTable
        members={nuclearMembers}
        title="Nuclear Members"
        renderActionButton={renderActionButton}
      />

      <MemberBenefitsTable
        members={parentMembers}
        title="Parent Members"
        renderActionButton={renderActionButton}
      />

      <MemberBenefitsTable
        members={extendedMembers}
        title="Extended Members"
        renderActionButton={renderActionButton}
      />

      {/* Action Buttons */}
      <div style={{ display: 'flex', gap: '15px', justifyContent: 'flex-end', marginTop: '30px' }}>
        <ButtonInc
          btnType="secondary"
          onClick={onCancel}
          style={{ border: '1px solid #032A37' }}
        >
          Cancel
        </ButtonInc>
        <ButtonInc
          btnType="primary"
          onClick={onNext}
        >
          Next
        </ButtonInc>
      </div>
    </div>
  );
};

export default UpgradePreviewScreen;
